/*
 * @Author: cc
 * @LastEditTime: 2022-06-17 17:21:06
 */
// import  { useEffect,useState } from "react";
// import { IsPc } from "../utils/index";
// import Style from "./index.module.scss"
import "moment/locale/zh-cn";
import { useLocation  } from "react-router-dom";
// import {get} from "../component/fetch"
// import store from '../reducers/index'
import logo from "../../../img/wx.png"
import { connect } from "react-redux";
import { IsPC } from "src/utils";
export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
const wxSubscript = (props:any) => {
  return (
    <>
        <div style={{height:"100vh",background:"#fff"}}><img style={{width:IsPC? "50%":"100%",display:"block",margin:"20px auto"}} src={logo} alt=""></img></div>
    </>
  );
};
const mapStateToProps = (state:any) => ({
  InitPageData: state.InitPageData, // 映射仓库中的某个变量到组件的props
});
export default connect(mapStateToProps)(wxSubscript);
